export default __webpack_public_path__ + "static/harvest-finance-logo-3a85662b13b50435780693d579be2475.png";